import React, {useEffect, useContext, createContext} from 'react';
import Socket from '../../Services/Socket';
import { usePreference } from '../../Data/Preference';
import { ulid } from 'ulid';
import API from '../../Services/API';
import { hashCode, useVisibilityChange } from '../../Services/helpers';

const SocketContext = createContext();

export const useSocketContext = () => {
    return useContext(SocketContext);
};

let reconnectInterval;
const subscriptions = {};

const Provider = ({children}) => {

    const [channelId] = usePreference('socket-channel', ulid(), true);

    useEffect(() => {
        Socket.connect();

        const onOpenUnsubscribe = Socket.onOpen(() => {
            // console.log('Socket connected!!');
            resubscribe();
        });
        const onCloseUnsubscribe = Socket.onClose(() => {
            // console.log('Socket closed. Reconnecting in 0.25 second');
            setTimeout(() => Socket.connect(), 250);
        });
        const onErrorUnsubscribe = Socket.onError(() => {
            // console.log('Socket errored. Reconnecting in 0.25 second');
            setTimeout(() => Socket.connect(), 250);
        });

        const onMessageUnsubscribe = Socket.onMessage(handleEvent);

        reconnectInterval = setInterval(() => {
            Socket.connect();
        }, 1000 * 10);

        return () => {
            onOpenUnsubscribe();
            onCloseUnsubscribe();
            onErrorUnsubscribe();
            onMessageUnsubscribe();
            clearInterval(reconnectInterval);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [channelId]);

    useVisibilityChange(() => {
        Socket.connect();
    });


    const handleEvent = (event) => {

        Object.values(subscriptions).forEach(sub => {
            const {subscription, callback} = sub;

            if (subscription?.channelId !== channelId) {
                return;
            }
            if (subscription?.topic && event?.topic !== subscription.topic) {
                return;
            }
            if (subscription?.entity?.entityId && event?.entityId !== subscription.entity.entityId) {
                return;
            }

            callback(event);
        });
    }

    const markSubscriptionForUnsubscribe = (subscriptionId) => {
        // delete subscriptions[subscriptionId];

        // Socket.send({
        //     action: 'unsubscribe',
        //     channelId,
        //     jwt: API.getToken(),
        //     ...sub
        // });
    }

    const subscribe = (subscription, callback) => {
        const subscriptionId = hashCode(subscription);

        subscriptions[subscriptionId] = {
            subscription: {channelId, ...subscription},
            callback,
        };

        Socket.send({
            action: 'subscribe',
            channelId,
            jwt: API.getToken(),
            ...subscription
        });

        return () => markSubscriptionForUnsubscribe(subscriptionId);
    }

    const resubscribe = () => {
        Object.values(subscriptions).forEach(sub => {
            // console.log('Resubscribing', sub);
            const {subscription, callback} = sub;
            subscribe(subscription, callback);
        });
    }

    const providerValues = {
        subscribe,
        getRecipient: (topic) => channelId+'_'+topic,
    };

    return <SocketContext.Provider value={providerValues}>
        {children}
    </SocketContext.Provider>
}

export default Provider;
